import React, { useMemo } from 'react';
import { MapPin, Repeat, Users } from 'lucide-react';
import {
  claveEvento, diaDelMes, fmtHora, nombreDiaCorto, sumarDias, textoDia, ymdDe,
} from '../../lib/calendario';
import { eventosDelDia } from './disposicion';

/** Agenda: solo los días que tienen algo, desde `desde`, `dias` días. */
export default function VistaAgenda({ desde, dias, tz, hoy, preparados, colorDe, onAbrir, onIrDia }) {
  const grupos = useMemo(() => {
    const salida = [];
    for (let i = 0; i < dias; i += 1) {
      const d = sumarDias(desde, i);
      const lista = eventosDelDia(preparados, d);
      if (lista.length) salida.push({ d, lista });
    }
    return salida;
  }, [desde, dias, preparados]);

  if (!grupos.length) {
    return (
      <div className="cal-vacio" data-testid="cal-agenda-vacia">
        <p>No hay eventos entre el {textoDia(desde, { day: 'numeric', month: 'long' })} y el {textoDia(sumarDias(desde, dias - 1), { day: 'numeric', month: 'long' })}.</p>
      </div>
    );
  }

  return (
    <div className="cal-agenda od-scroll" data-testid="cal-agenda">
      {grupos.map(({ d, lista }) => (
        <section key={d} className={`cal-agenda-dia ${d === hoy ? 'is-hoy' : ''}`}>
          <button type="button" className="cal-agenda-fecha" onClick={() => onIrDia(d)}>
            <span className="cal-agenda-num">{diaDelMes(d)}</span>
            <span className="cal-agenda-sem">{textoDia(d, { month: 'short' }).replace('.', '')}, {nombreDiaCorto(d)}</span>
          </button>
          <div className="cal-agenda-lista">
            {lista.map((p) => {
              const ev = p.ev;
              let hora = 'Todo el día';
              if (!ev.todo_el_dia) {
                const ini = ymdDe(ev.inicio, tz);
                const fin = ymdDe(new Date(new Date(ev.fin).getTime() - 1), tz);
                if (ini === d && fin === d) hora = `${fmtHora(ev.inicio, tz)} – ${fmtHora(ev.fin, tz)}`;
                else if (ini === d) hora = `Desde ${fmtHora(ev.inicio, tz)}`;
                else if (fin === d) hora = `Hasta ${fmtHora(ev.fin, tz)}`;
              }
              return (
                <button
                  type="button"
                  key={`${claveEvento(ev)}-${d}`}
                  className="cal-agenda-ev cal-ev"
                  onClick={(e) => onAbrir(ev, e.currentTarget.getBoundingClientRect())}
                  style={{ opacity: new Date(ev.fin) < Date.now() ? 0.66 : 1 }}
                  data-testid="cal-evento"
                >
                  <span className="cal-punto" style={{ background: ev.mi_estado === 'pendiente' ? 'transparent' : colorDe(ev), borderColor: colorDe(ev) }} />
                  <span className="cal-agenda-hora">{hora}</span>
                  <span className="cal-agenda-titulo" style={{ textDecoration: ev.mi_estado === 'rechazado' ? 'line-through' : undefined }}>
                    {ev.titulo || '(Sin título)'}
                    {(ev.rrule || ev.serie_id) && <Repeat className="cal-agenda-ico" aria-label="Se repite" />}
                    {ev.invitados?.length ? <Users className="cal-agenda-ico" aria-label="Con invitados" /> : null}
                    {ev.ubicacion && <span className="cal-agenda-lugar"><MapPin className="cal-agenda-ico" />{ev.ubicacion}</span>}
                  </span>
                </button>
              );
            })}
          </div>
        </section>
      ))}
    </div>
  );
}
